import React, { memo } from 'react'
import { string, func, object, number } from 'prop-types'
import serverData from '../utils/server-data'
import { fptiCustomClick } from '../utils/fpti'

import { BodyText, Row, Col, Divider } from '@paypalcorp/pp-react'

const { isInFrame, locality = {} } = serverData
const directionality = locality.directionality || 'ltr'

const SubSection = memo((props) => {
  const {
    subSectionId,
    title,
    desc,
    onSectionClick,
    modal = null,
    navigateTo,
    fptiClickData,
    subModule = {},
    action,
    tabIndex,
  } = props

  const internalTypeCheck = (nav, tempModal) => {
    if (isInFrame || !tempModal) {
      top.location.href = nav
    } else {
      onSectionClick(tempModal)
    }
  }
  const onClickSubSection = (type) => {
    fptiCustomClick(fptiClickData)
    if (!type) {
      internalTypeCheck(navigateTo, modal)
    }

    if (type === 'subModule') {
      const { modal: subModuleModal = null, navigateTo: subnavigateTo } =
        subModule
      internalTypeCheck(subnavigateTo, subModuleModal)
    }
  }
  return (
    <div className="merchant-subSection-container_row" id={subSectionId}>
      <div className="merchantSectionDetails">
        <Row className="merchant-row-container">
          <div className="merchantSectionWrapper">
            <section className="column-1">
              <BodyText type="strong" className="merchantSectionTitle">
                {title}
              </BodyText>
            </section>
            <section className="column-2">
              <BodyText className="merchantSectionContent">{desc}</BodyText>
            </section>
          </div>
          <div className="merchantSectionAction">
            <BodyText>
              <a
                id={`${subSectionId}Btn`}
                data-testid="merchantsectionactionid"
                tabIndex={tabIndex}
                onClick={() => onClickSubSection()}
              >
                {action}
              </a>
            </BodyText>
          </div>
        </Row>
      </div>
      {Object.keys(subModule).length > 0 && subModule.enabled() && (
        <div
          id={subModule.subModuleId}
          className="merchant-subSection-module merchantSubModuleDetails"
        >
          <div className="merchant-subSection-module-divider_container">
            <Divider secondary className="merchant-subSection-module-divider" />
          </div>
          <Row className="merchant-subSection-module_borderLeft">
            <div className={`merchantSubModuleWrapper ${directionality}`}>
              <Col>
                <section className="merchant-sub-module-badge-row">
                  <BodyText type="strong" className="merchantSubModuleTitle">
                    {subModule.title}
                  </BodyText>
                  <div className="merchantSubModuleBadge">
                    {subModule.badgeStatus()}
                  </div>
                </section>

                <BodyText className="merchantSubModuleTitle">
                  {subModule.desc}
                </BodyText>
              </Col>
            </div>
            <div className="merchantSubModuleAction">
              <BodyText>
                <a
                  id={`${subModule.subModuleId}-${subModule.action}`}
                  data-testid="merchantSubModule"
                  tabIndex={tabIndex}
                  onClick={() => onClickSubSection('subModule')}
                >
                  {subModule.action}
                </a>
              </BodyText>
            </div>
          </Row>
        </div>
      )}
    </div>
  )
})

SubSection.propTypes = {
  subSectionId: string,
  title: object,
  desc: object,
  fptiClickData: object,
  navigateTo: string,
  modal: object,
  subModule: object,
  onSectionClick: func.isRequired,
  action: string,
  tabIndex: number,
}

SubSection.displayName = 'SubSection'

export default SubSection
